export enum BasesRoute {
  BASES_LIST = '/management-panel/bases',
  ADD_BASE = '/management-panel/bases/add',
  BASE_CARD = '/management-panel/bases/:uuid',
  EDIT_BASE = '/management-panel/bases/:uuid/edit',
}
